import { Flex } from 'antd'

const Mappings = ({ mappings, title, isOneLine = false }) => {
  return (
    mappings?.length > 0 && (
      <Flex className="dtc-review-expanded-rows full-width">
        <p className="connector-type bolder">{title}: </p>
        <div className="connector-list">
          {isOneLine
            ? mappings.map((mapping, index) => (
                <span
                  key={`${mapping?.name}-${index}`}
                  className="connector-name underline"
                >
                  {mapping?.name}
                </span>
              ))
            : mappings.map((mapping, index) => (
                <div key={index} className="connector-details">
                  <p className="connector-name underline">
                    {mapping?.name ? mapping?.name : mapping?.id}
                  </p>
                  <p className="connector-description">
                    {mapping?.description}
                  </p>
                </div>
              ))}
        </div>
      </Flex>
    )
  )
}

export default Mappings
